/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedContactDealerButton_item = {
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_item">;
    readonly " $refType": "PdpSharedContactDealerButton_item";
};
export type PdpSharedContactDealerButton_item$data = PdpSharedContactDealerButton_item;
export type PdpSharedContactDealerButton_item$key = {
    readonly " $data"?: PdpSharedContactDealerButton_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactDealerButton_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedContactDealerButton_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '7c677a2f77eb61fc77fbd1a29f460f4a';
export default node;
